import {call, put, select} from "redux-saga/effects";
import * as api from "services/api";
import {errorPeopleSearch, startPeopleSearch, successPeopleSearch} from "./reducer";
import {getErrorFromMessage} from "services/utils/utils";
import {peopleSearchCurrentPage, peopleSearchFilters} from "features/pages/people/search/selectors";

export function* searchPeopleSaga() {
    const filters = yield select(peopleSearchFilters);
    const page = yield select(peopleSearchCurrentPage);
    try {
        const data = yield call([api, api.searchPeopleApi], filters, page);
        yield put(successPeopleSearch(data));
    } catch (e) {
        console.log(e);
        yield put(errorPeopleSearch(getErrorFromMessage(e)));
    }
}
export function* searchPeopleFiltersSetSaga() {
    yield put(startPeopleSearch());
}